import React, { useEffect, useRef } from 'react';

const FloatingParticles = ({ count = 15, color = 'var(--accent-color)' }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        // Create particles
        const particles = [];
        for (let i = 0; i < count; i++) {
            const particle = document.createElement('div');
            particle.className = 'particle';
            
            // Random size between 3-8px (larger)
            const size = Math.random() * 5 + 3;
            particle.style.width = `${size}px`;
            particle.style.height = `${size}px`;
            
            // Random starting position
            particle.style.left = `${Math.random() * 100}%`;
            particle.style.top = `${Math.random() * 100}%`;
            
            // Random animation duration between 10-20s
            const duration = Math.random() * 10 + 10;
            particle.style.animationDuration = `${duration}s`;
            
            // Random animation delay
            const delay = Math.random() * 5;
            particle.style.animationDelay = `${delay}s`;
            
            // Random horizontal offset
            const xOffset = (Math.random() - 0.5) * 100;
            particle.style.setProperty('--x-offset', `${xOffset}px`);
            
            container.appendChild(particle);
            particles.push(particle);
        }

        // Cleanup
        return () => {
            particles.forEach(particle => particle.remove());
        };
    }, [count]);

    return (
        <div 
            ref={containerRef} 
            className="particles"
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                pointerEvents: 'none',
                zIndex: 2
            }}
        >
            <style jsx="true">{`
                @keyframes floatUp {
                    0% {
                        transform: translateY(0) translateX(0) scale(0.5);
                        opacity: 0;
                    }
                    10% {
                        opacity: 0.8;
                        transform: translateY(-10vh) translateX(calc(var(--x-offset, 50px) * 0.1)) scale(1);
                    }
                    50% {
                        opacity: 1;
                        transform: translateY(-50vh) translateX(calc(var(--x-offset, 50px) * 0.5)) scale(1.2);
                    }
                    90% {
                        opacity: 0.8;
                        transform: translateY(-90vh) translateX(calc(var(--x-offset, 50px) * 0.9)) scale(0.8);
                    }
                    100% {
                        transform: translateY(-100vh) translateX(var(--x-offset, 50px)) scale(0.3);
                        opacity: 0;
                    }
                }

                .particle {
                    position: absolute;
                    background: ${color};
                    border-radius: 50%;
                    opacity: 0.6;
                    animation: floatUp 15s infinite ease-in-out;
                    box-shadow: 
                        0 0 15px ${color},
                        0 0 30px ${color},
                        0 0 45px rgba(201, 169, 110, 0.3);
                }
            `}</style>
        </div>
    );
};

export default FloatingParticles;
